module.exports = __webpack_public_path__ + "img/empty.39d7a420.png";